import React, { useState, useEffect } from "react";
import { Link, navigate } from "gatsby";
import { isLoggedIn, logout } from "../services/auth.mjs";
import { Key, LogOut } from "react-feather";
import logo from "../images/logo.min.svg";
import logodark from "../images/darkthemelogo.svg";
import ThemeSwitcher from "../theme-switcher";
import {
  getLanguage,
  toggleLanguage,
  subscribe,
} from "../language/LanguageSetting.js";

export default function NavBar({ location }) {
  // Login state and language both come from localStorage, which does not exist
  // during SSR. The first client render must match the server's markup exactly
  // or React aborts hydration and tears down the tree, which breaks widgets
  // that attach to real DOM nodes (Leaflet, Flatpickr). So render the server's
  // view until after mount, then switch.
  const [mounted, setMounted] = useState(false);
  const [isFinnish, setIsFinnish] = useState(true);

  useEffect(() => {
    setMounted(true);
    setIsFinnish(getLanguage());

    const unsubscribe = subscribe(() => {
      setIsFinnish(getLanguage()); // Update language when changed
    });

    return () => unsubscribe(); // Cleanup on unmount
  }, []);

  const loggedIn = mounted && isLoggedIn();

  const texts = isFinnish
    ? {
        etusivulle: "Etusivulle",
        resurssit: "Resurssit",
        kartta: "Kartta",
        asetukset: "Asetukset",
        kirjaudusisään: "Kirjaudu sisään",
        kirjaudu: "Kirjaudu",
        kirjauduulos: "Kirjaudu ulos",
      }
    : {
        etusivulle: "To the front page",
        resurssit: "Resources",
        kartta: "Map",
        asetukset: "Settings",
        kirjaudusisään: "Log in",
        kirjaudu: "Login",
        kirjauduulos: "Log out",
      };

  const logOutHouse = () => {
    window.localStorage.removeItem("session");
    window.localStorage.removeItem("account");
    window.localStorage.removeItem("access");
  };

  const isCondoResourcesPage = location.pathname === "/app/resources/";

  return (
    <header className="sticky left-0 top-0 z-[1000] h-16 w-full bg-white shadow-md dark:bg-dark-navbar md:h-20">
      <div className="flex h-full items-center justify-between px-6 py-4 lg:px-8 lg:py-6 xl:px-4">
        <Link to="/">
          <span className="sr-only">Opasti</span>
          <img
            title={texts.etusivulle}
            className="fade-in block h-9 dark:hidden"
            alt=""
            src={logo}
          />
          <img
            title={texts.etusivulle}
            className="fade-in sticky hidden h-9 object-contain dark:block"
            alt=""
            src={logodark}
          />
        </Link>
        {/* <> //Support
          <Link
            to="/app/support"
            className="flex space-x-1 hover:text-gray-500 hover:no-underline"
          >
            <button className="flex flex-row justify-between float-right px-0 m-0">
              <HelpCircle className="h-5 pt-1" />
              Tuki
            </button>
          </Link>
        </> */}

        {loggedIn && (
          <nav className="flex items-center space-x-6">
            <Link to="/app/handle">{texts.resurssit}</Link>
            <Link to="/app/map">{texts.kartta}</Link>
          </nav>
        )}

        <nav className="flex items-center gap-2 space-x-4">
          {loggedIn ? (
            <>
              <Link to="/app/profile" className="hover:no-underline">
                {texts.asetukset}
              </Link>

              {!isCondoResourcesPage && (
                <a
                  href="/"
                  onClick={(event) => {
                    event.preventDefault();
                    logout(() => navigate("/app/access"));
                  }}
                >
                  <LogOut className="h-5 w-5 sm:inline" />
                </a>
              )}
            </>
          ) : (
            !isCondoResourcesPage && (
              <Link
                to="/app/access/"
                className="flex items-center space-x-1 hover:text-gray-500 hover:no-underline"
              >
                <button
                  title={texts.kirjaudusisään}
                  className="btn -primary m-0 flex w-32 flex-row justify-between px-0 pl-4 pr-6"
                >
                  <Key className="h-5" />
                  {texts.kirjaudu}
                </button>
              </Link>
            )
          )}

          {isCondoResourcesPage && <ThemeSwitcher />}

          <button onClick={toggleLanguage}>
            {isFinnish ? "In English" : "Suomeksi"}
          </button>

          {isCondoResourcesPage && (
            <a
              href="/"
              title={texts.kirjauduulos}
              onClick={() => {
                logOutHouse(() => navigate("/app/access"));
              }}
            >
              <LogOut className="h-7 w-7 sm:inline" />
            </a>
          )}
        </nav>
      </div>
    </header>
  );
}
